import { render, staticRenderFns } from "./FouthCur.vue?vue&type=template&id=6f465e41&scoped=true&"
import script from "./FouthCur.vue?vue&type=script&lang=js&"
export * from "./FouthCur.vue?vue&type=script&lang=js&"
import style0 from "./FouthCur.vue?vue&type=style&index=0&id=6f465e41&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f465e41",
  null
  
)

export default component.exports